import { Modal, Type } from '@robinhood/design';

import Button from 'src/components/creditApplication/Button';
import { LayoutStyle } from 'src/constants/styles';
import { TextStyle } from 'src/constants/styles';

interface PropsIface {
  onDismiss: () => void;
}

const GoldSubscriptionInfoModal = ({ onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={LayoutStyle.p0} onClose={onDismiss}>
      <div css={[LayoutStyle.ph24, LayoutStyle.pv32, LayoutStyle.colAC, LayoutStyle.w100]}>
        <Type.Display size='S'>{'Robinhood Gold'}</Type.Display>
        <br />
        <Type.Text size='M' overrideRootStyles={TextStyle.textCenter}>
          {
            'The Gold Card requires an annual Robinhood Gold subscription to apply and maintain the card and does not include a 30 day free trial. Students are eligible to receive a credit for the amount of the annual Gold subscription charge until graduation or four years measured from account opening, whichever comes first. Robinhood will reimburse the annual Gold subscription charge by posting a credit to your Robinhood Gold Card account in the amount of the charge within 1 day of when the subscription is billed.'
          }
        </Type.Text>
        <Button
          overrideButtonStyles={LayoutStyle.mt32}
          variant='secondary'
          label='Dismiss'
          width='full'
          type='button'
          onClick={onDismiss}
        />
      </div>
    </Modal>
  );
};

export default GoldSubscriptionInfoModal;
